module.exports = __webpack_public_path__ + "img/lumeris-logo-white.77ad68f6.svg";